<form #form="ngForm" novalidate (submit)="form.valid && onSubmit()">
  <div class="modal-header">
    <h4 class="h4 modal-title">
      <span i18n>Edit profile</span>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true"><i class="cc-icon cc-icon-close"></i></span>
    </button>
  </div>
  <div class="modal-body form">
    <div *ngIf="user" class="animate-fade-in">
      <div class="form-group row">
        <label class="default-label col-sm-4" i18n> Email </label>
        <div class="col-sm-8">
          <span>{{ user.email }}</span>
        </div>
      </div>
      <div class="form-group row">
        <label class="default-label col-form-label col-sm-4" i18n> First name </label>
        <div class="col-sm-8">
          <span *ngIf="!isAdmin">{{ user.firstName }}</span>
          <div *ngIf="isAdmin">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="user.firstName"
              required
              #firstName="ngModel"
              name="firstName"
              id="firstName"
              placeholder="First name"
              i18n-placeholder="First name"
            />
            <div class="sm-text-default-red" i18n *ngIf="form.submitted && firstName.invalid">
              First name is required
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="default-label col-form-label col-sm-4" i18n> Last name </label>
        <div class="col-sm-8">
          <span *ngIf="!isAdmin">{{ user.lastName }}</span>
          <div *ngIf="isAdmin">
            <input
              type="text"
              class="form-control"
              [(ngModel)]="user.lastName"
              #lastName="ngModel"
              name="lastName"
              id="lastName"
              required
              placeholder="Last name"
              i18n-placeholder="Last name"
            />
            <div class="sm-text-default-red" i18n *ngIf="form.submitted && lastName.invalid">
              Last name is required
            </div>
          </div>
        </div>
      </div>
      <div class="form-group row" [ngClass]="{ 'has-danger': form.submitted && mobile.invalid }">
        <label class="default-label col-form-label col-sm-4" i18n for="mobile"> Mobile </label>
        <div class="col-sm-8">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="user.mobile"
            #mobile="ngModel"
            name="mobile"
            id="mobile"
            required
            pattern="\+?\d+"
            placeholder="Mobile"
            i18n-placeholder="Mobile"
          />
          <div class="sm-text-default-red" *ngIf="mobile.invalid && mobile.dirty">
            <div *ngIf="mobile.errors.required">Mobile is required</div>
            <div *ngIf="mobile.errors.pattern">Invalid mobile number</div>
          </div>
        </div>
      </div>
      <div class="form-group row" [class.has-danger]="!user.signature && !signatureData">
        <label i18n class="default-label col-form-label col-sm-4">Signature </label>
        <div class="col-sm-8">
          <div>
            <div class="signature-wrapper d-flex">
              <div *ngIf="user.signature">
                <cc-signature-pad [src]="user.signature" [height]="107" [width]="280"></cc-signature-pad>
              </div>
              <input
                type="hidden"
                [(ngModel)]="signatureData"
                [required]="!user.signature && !isAdmin"
                name="signature"
                #signature="ngModel"
              />

              <div *ngIf="!user.signature && !isAdmin && showSigPad">
                <cc-signature-pad
                  [options]="signaturePadOptions"
                  (end)="drawComplete($event)"
                ></cc-signature-pad>
              </div>
              <label class="default-label btn btn-primary" *ngIf="!user.signature && !isAdmin && showUpload">
                <span i18n>Upload signature</span>
                <span class="loading-spinner" *ngIf="uploading">
                  <i class="cc-icon cc-icon-spinner-fw"></i>
                </span>
                <input
                  type="file"
                  name="file"
                  class="d-none"
                  (change)="uploadSignature($event)"
                  accept="image/*"
                />
              </label>
              <div class="ml-3" *ngIf="!isAdmin">
                <button
                  type="button"
                  *ngIf="user.signature"
                  class="btn btn-secondary btn-sm"
                  title="Remove"
                  i18n-title="Remove"
                  (click)="removeSignature()"
                >
                  <i class="cc-icon cc-icon-delete sm-text-default-red"></i>
                </button>
                <button
                  type="button"
                  *ngIf="!user.signature && showSigPad"
                  class="btn btn-secondary btn-sm"
                  title="Clear"
                  i18n-title="Clear"
                  (click)="clearSignature()"
                >
                  <i class="cc-icon cc-icon-undo"></i>
                </button>
              </div>
            </div>
            <div
              class="sm-text-default-red"
              data-test="signature-invalid"
              i18n
              *ngIf="!user.signature && !signatureData"
            >
              Signature is required
            </div>
          </div>
          <div *ngIf="!user.signature && !isAdmin">
            <small *ngIf="showSigPad">
              <p i18n class="mb-0 mt-2">Draw your signature above.</p>
              <span>Or you can </span>
              <a i18n class="text-link" (click)="showSigPad = false; showUpload = true">click here</a>
              <span i18n> to upload an image of your signature.</span></small
            >
            <small *ngIf="showUpload"
              ><span i18n>Or, you can </span>
              <a i18n class="text-link" (click)="showSigPad = true; showUpload = false">click here</a>
              <span i18n> to draw your signature.</span></small
            >
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="default-label col-form-label col-sm-4" i18n for="mobile"> Time zone </label>
        <div class="col-sm-8">
          <ng-select
            name="timezone"
            [items]="timezones"
            [(ngModel)]="user.timezone"
            bindValue="value"
            i18n-placeholder="Select timezone"
            placeholder="Select timezone"
          >
          </ng-select>
        </div>
      </div>
    </div>
    <div class="text-center mt-5 mb-3">
      <button type="submit" data-test="submit-btn" class="btn btn-success" [ccBusyButton]="working">
        Save
      </button>
    </div>
  </div>
</form>
